import React from 'react';
import {createHashRouter, Outlet, RouterProvider} from "react-router-dom";
import styles from './App.module.css';
import Home from "./pages/Home";
import Header from "./components/Header/Header";
import AllChannels from "./pages/AllChannels";
import SelectedChannelProvider from "./context/channel/SelectedChannelContext";
import ChannelHistoryProvider from "./context/channel/ChannelHistoryContext";
import AccountProvider from "./context/account/AccountContext";
import Shortlist from "./pages/Shortlist";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import CategoryBrowser from "./pages/CategoryBrowser";
import SeriesBrowser from "./pages/SeriesBrowser";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

function App() {
    const Layout = () => (
        <div className={styles.appContainer}>
            <Header/>
            <main className={styles.mainContent}>
                <Outlet/>
            </main>
        </div>
    );

    const routers = createHashRouter([
        {
            element: <Layout/>,
            children: [
                {
                    path: "/",
                    element: <Home/>
                },
                {
                    path: "/allChannels",
                    element: <AllChannels/>
                },
                {
                    path: "/shortlist",
                    element: <Shortlist/>
                },
                {
                    path: "/live",
                    element: <CategoryBrowser/>
                },
                {
                    path: "/movies",
                    element: <CategoryBrowser/>
                },
                {
                    path: "/series",
                    element: <SeriesBrowser/>
                },

            ]
        }
    ]);

    return (
        <div className={styles.viewport}>
            <QueryClientProvider client={queryClient}>
                <AccountProvider>
                    <ChannelHistoryProvider>
                        <SelectedChannelProvider>
                            <RouterProvider router={routers}/>
                        </SelectedChannelProvider>
                    </ChannelHistoryProvider>
                </AccountProvider>
            </QueryClientProvider>
        </div>
    );
}

export default App;
